// Which API-key build variables are empty in THIS build. A Cloudflare Pages
// build that lacks one of them used to fall back silently (SocialHub.jsx once
// carried a hardcoded key for exactly that case); now the app says so instead.
export function missingKeyVars(values) {
  return Object.keys(values).filter((name) => !values[name]);
}

// Literal property reads (not process.env[name]) so Create React App inlines
// each value at build time.
export const MISSING_KEY_VARS = missingKeyVars({
  REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
  REACT_APP_MEDIA_STUDIO_API_KEY: process.env.REACT_APP_MEDIA_STUDIO_API_KEY,
});
